<div class="global-notification-confirm-popup" [ngClass]="{ 'dark-theme': isDarkMode }">
  <div class="notification-preview">
    <h4>Aperçu de la notification :</h4>
    <div class="preview-card">
      <mat-icon class="notification-icon">notifications</mat-icon>
      <div class="notification-content">
        <span class="notification-title">{{'mainNav.notificationsMenu.update' | translate }}</span>
        <p class="notification-text">{{ input?.message }}</p>
      </div>
    </div>
  </div>
</div>